import { useRef } from 'react';
import TargetMarketPlanEdit from './TargetMarketPlanEdit';
import classes from './tmsEdit.module.scss';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import SalesPlanEditScreen from 'screens/FDPScreen/components/TargetMarketShare/TargetMarketShareEditScreen/SalesPlanEditScreen';
import { observer } from 'mobx-react';
import { useStore } from 'hooks/useStore';

const TMSEditComponent = () => {
  const stepperRef = useRef<React.ComponentRef<typeof Stepper> | null>(null);
  const {
    MSPlanStore: { msPlanStatusCheck },
  } = useStore();

  return (
    <div className={classes.targetMarketEditContainer}>
      <div style={{ width: '100%' }}>
        <Stepper ref={stepperRef} linear={!msPlanStatusCheck}>
          <StepperPanel header="Market Share Plan">
            <TargetMarketPlanEdit next={() => stepperRef.current?.nextCallback()} />
          </StepperPanel>
          <StepperPanel header="Sales Plan">
            <SalesPlanEditScreen />
          </StepperPanel>
        </Stepper>
      </div>
    </div>
  );
};

export default observer(TMSEditComponent);
